import NProgress from "nprogress";
import store from '@/store';

export const beforeEachGuard = async (to, from, next) => {
    NProgress.start();
    if (!store.getters.isAuthenticated) {
        await store.dispatch('Login');
    }
    /* Authorization handling through router meta */
    if (to.matched.some((route) => route.meta.auth)) {
        //if (!store.getters.isAuthenticated) {
        //    /* The user is not authorized */
        //    next({ path: "/errAuth" });
        //} else {
        /* The user is authorized */
        if (to.matched.some((route) => route.meta.role && store.getters.isInRoleArr(route.meta.role))) {
            /* The user has the required roles */
            next();
        } else if (!to.matched.some((route) => route.meta.role)) {
            /* This page has no required roles */
            next();
        } else {
            /* The user does not have the required roles */
            next({ path: '/errAuth' });
        }
        // }
    } else {
        /* This page does not require authentication */
        next();
    }
};

export const afterEachGuard = (to, from) => {
    NProgress.done();
};
